import React from 'react';
import { motion } from 'framer-motion';

// `blur` and `hover` both promote a card to its own GPU compositing layer.
// That is fine for small cards, but the module reader renders single cards
// ~10,000px tall — past iOS Safari's max layer texture size, where the layer
// mis-paints and siblings (the Continue/Back nav) appear over the text.
// Long reading surfaces pass hover={false} blur={false} and stay uncomposited.
const Card = ({
  children,
  className = '',
  hover = true,
  blur = true,
  ...props
}) => {
  return (
    <motion.div
      whileHover={hover ? { y: -2 } : {}}
      className={`
        bg-slate-800/80 ${blur ? 'backdrop-blur-sm' : ''} rounded-xl p-6 border border-slate-700
        ${hover ? 'card-hover' : ''} 
        ${className}
      `}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Card;
